
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutationReportOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"docEntry"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"docNum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportFormSubmit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"orderList","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"docEntry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"docEntry"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"docNum"},"value":{"kind":"Variable","name":{"kind":"Name","value":"docNum"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cardName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardName"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allReports"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docNum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docDueDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"net"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gross"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docEntry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"debt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditLimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"base64"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"saldoCommodity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docEntryDocument"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"saldoServices"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"balance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overdue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional5"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":891}};
    doc.loc.source = {"body":"mutation mutationReportOrder($cardCode : String!, $docEntry : String!, $docNum : String!, $userId: String!, $country: String!, $cardName: String!){\n   reportFormSubmit(\n     input:{\n        type: \"orderList\"\n        customerId: $cardCode\n        userId: $userId\n        docEntry: $docEntry \n        docNum: $docNum\n        country: $country\n        cardName: $cardName\n     }\n   ){\n       allReports{\n           docNum\n           docDate\n           docDueDate\n           status\n           net\n           vat\n           gross\n           docEntry\n           message\n           debt\n           currency\n           creditLimit\n           base64\n           saldoCommodity\n           docEntryDocument\n           saldoServices\n           balance\n           overdue\n           additional1\n           additional2\n           additional3\n           additional4\n           additional5\n       }\n\n   }\n }\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["mutationReportOrder"] = oneQuery(doc, "mutationReportOrder");
        
